<template>
    <v-container>
        <h1 class="titulo mb-3">CONFIGURAÇÃO DE ÍNDICES DE CORREÇÃO</h1>
        <!-- Formulário de Inserção -->
        <v-card class="card">
            <v-card-text>
                <m-form ref="form">
                    <v-row>
                        <v-col cols="6" md="4">
                            <v-text-field
                                    label="Informe o Código do Índice:"
                                    v-model="novoIndice.codigo"
                                    v-input-filter="[$filters.numericComVirgula]"
                                    outlined
                                    maxlength="225"
                                    class="required"
                                    :rules="[$rules.required]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-text-field
                                    label="Informe a Tag:"
                                    v-model="novoIndice.tag"
                                    v-input-filter="[$filters.textnumericNoSpace]"
                                    outlined
                                    maxlength="225"
                                    class="required"
                                    :rules="[$rules.required]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-text-field
                                    label="Informe a Descrição:"
                                    v-model="novoIndice.descricao"
                                    v-input-filter="[$filters.textnumeric]"
                                    outlined
                                    maxlength="225"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4">
                            <HintMessage style="max-width: 450px;" class="mt-8 mb-5" title="DICA PARA CONFIGURAÇÃO"
                                         icon="mdi-lightbulb-on-outline" icon-color="secondary"
                                         description="<p>É possível parametrizar mais de um código por tag ao separar os códigos por vírgula</br><strong>Exemplo:</strong> 099,098,097,... <p>O campo 'tag' não aceita caracteres especiais.</p></p>"
                                         :description-html="true"
                                         :center-icon="true" />
                        </v-col>
                    </v-row>
                    <v-row class="mb-6">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn class="transition" color="primary" rounded @click="adicionarIndice">
                                Salvar
                            </v-btn>
                        </v-col>
                    </v-row>
                </m-form>

                <!-- Filtros -->
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition ml-1" color="primary" rounded @click="toggleFiltro">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn class="transition mr-1" color="primary" @click="download()">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        Salvar Relatório
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" v-show="filter_open" class="mt-4 ml-2">
                        <v-row>
                            <v-col cols="6">
                                <m-text-field
                                        outlined
                                        label="Informe o Código do Índice:"
                                        v-model="dtFiltro.codigo"
                                        v-input-filter="[$filters.numericComVirgula]"
                                />
                            </v-col>
                            <v-col cols="6">
                                <m-text-field
                                        outlined
                                        label="Informe a Tag:"
                                        v-model="dtFiltro.tag"
                                        v-input-filter="[$filters.textnumeric]"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="d-flex justify-start">
                                <v-btn color="secondary" @click="limpar">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="d-flex justify-end">
                                <v-btn color="primary" @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>

                <!-- Tabela de Listagem -->
                <DataTable
                        ref="datatable"
                        url="/painel/indice_correcao/listar"
                        class="pt-2 data-table-overlow"
                        :params="params"
                        :headers="headers"
                        :filter="dtFiltro"
                >
                    <template v-slot:items="{item}">
                        <td class="text-center">
                            <div class="codigo-container">
                                <span
                                        v-for="(codigo, index) in parseCodigo(item.codigo)"
                                        :key="index"
                                        class="badge"
                                >
                                    {{ codigo }}
                                </span>
                            </div>
                        </td>
                        <td class="text-center">{{ item.tag }}</td>
                        <td class="text-center">{{ item.descricao || ' - ' }}</td>
                        <td class="text-center">
                            <v-btn icon>
                                <v-icon @click="removerIndice(item.id)">ol-delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { notification, alert } from '@/plugins/helpers'
  import { AlertTypes } from '@/plugins/alerts_types'
  import * as Qs from 'qs'

  export default {
    name: 'IndicesCorrecaoValidos',
    data: () => ({
      pagination: {
        sortBy: [], descending: []
      },
      novoIndice: {
        codigo: '',
        tag: '',
        descricao: ''
      },
      headers: [
        { text: 'Código do Índice', value: 'codigo', align: 'center', sortable: false },
        { text: 'Tag', value: 'tag', align: 'center', sortable: false },
        { text: 'Descrição', value: 'descricao', align: 'center', sortable: false },
        { text: '', value: 'actions', sortable: false }
      ],
      dtFiltro: {
        codigo: '',
        tag: ''
      },
      filter_open: false
    }),
    computed: {
      params () {
        return { pagination: this.pagination }
      }
    },
    methods: {
      async adicionarIndice () {
        if (!this.novoIndice.codigo || !this.novoIndice.tag) {
          notification(AlertTypes.WARN, 'Por favor, preencha os campos obrigatórios.')
          return
        }

        try {
          await this.$http.post('/painel/indice_correcao/inserir', this.novoIndice)
          notification(AlertTypes.SUCCESS, 'Configuração de índice de correção salva com sucesso!')
          this.resetForm()
          this.$refs.datatable.reload()
        } catch (error) {
          notification(
            AlertTypes.ERROR,
            error.response?.data?.error || 'Erro ao salvar a configuração de  índice de correção.'
          )
        }
      },
      removerIndice (id) {
        alert({
          text: `Tem certeza que deseja excluir esta configuração de índice?`,
          buttons: {
            Cancelar: () => true,
            Confirmar: async () => {
              try {
                await this.$http.delete(`/painel/indice_correcao/excluir/${id}`)
                notification(AlertTypes.SUCCESS, 'Configuração de índice excluída com sucesso!')
                this.$refs.datatable.reload()
              } catch (error) {
                notification(
                  AlertTypes.ERROR,
                  error.response?.data?.error || 'Erro ao excluir a configuração do índice de correção.'
                )
              }
            }
          }
        })
      },
      download () {
        const filtros = { ...this.dtFiltro }
        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        try {
          window.open(`${this.ws}/indices_de_correcao/exportar?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      filtrar () {
        this.$refs.datatable.reload({
          codigo: String(this.dtFiltro.codigo || '').trim(),
          tag: String(this.dtFiltro.tag || '').trim()
        })
      },
      resetForm () {
        this.novoIndice = {
          codigo: '',
          tag: '',
          descricao: ''
        }
        this.$refs.form.resetValidation()
      },
      limpar () {
        this.dtFiltro = { codigo: '', tag: '' }
        this.filtrar()
        this.filter_open = false
      },
      parseCodigo (codigo) {
        return codigo.split(',').map((c) => c.trim())
      }
    }
  }
</script>

<style scoped>
.codigo-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}

.badge {
  background-color: #ebe9e9;
  color: #333333;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
}

.badge:hover {
  background-color: #d6d4d4;
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.v-icon {
  cursor: pointer;
}
</style>
